import actions from 'actions'
import { PERFORMANCES_VIEW_CURRENT, PERFORMANCES_VIEW_PAST } from 'constants/eventgroup-page-constants'
import { getCurrentPartnerId, getIdentityPortalUser } from 'selectors/settings'
import { getCurrentSetupformId, isTracked } from 'selectors/setupform'
import { getEmail } from 'selectors/signup'
import { fromTicketing } from 'utils/urls'

export default {
  [actions.HOME_LOAD_PAST_EVENT_GROUPS]: [
    action => (action.nextPage ? {
      name: 'Loaded more eventgroups',
      properties: { partnerId: action.partnerId },
    } : null),
  ],

  [actions.EVENT_GROUP_LOAD_PERFORMANCES]: [
    action => (action.nextPage ? {
      name: 'Loaded more current performances',
      properties: { eventGroupId: action.eventGroupId },
    } : null),
  ],

  [actions.EVENT_GROUP_LOAD_PAST_PERFORMANCES]: [
    action => (action.nextPage ? {
      name: 'Loaded more past performances',
      properties: { eventGroupId: action.eventGroupId },
    } : null),
  ],

  [actions.EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE]: [
    action => (action.viewType === PERFORMANCES_VIEW_CURRENT ? {
      name: 'Viewed current perfomances',
    } : null),
  ],

  [actions.EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE]: [
    action => (action.viewType === PERFORMANCES_VIEW_PAST ? {
      name: 'Viewed past perfomances',
    } : null),
  ],

  [actions.SIGNUP_START]: [
    () => ({
      name: 'Partner creation started',
      properties: {
        category: 'Self service signup',
      },
    }),
  ],

  [actions.SIGNUP_REQUEST.SUCCESS]: [
    action => ({
      name: 'Partner creation completed',
      properties: {
        category: 'Self service signup',
        partnerId: action.response.partnerId,
        partnerType: 'self-service',
        portalUserEmailAddress: action.response.email,
        portalUserId: action.response.portalUserId,
      },
    }),
  ],

  [actions.SIGNUP_REQUEST.FAILURE]: [
    (action, state) => ({
      name: 'Partner creation failed',
      properties: {
        category: 'Self service signup',
        email: getEmail(state),
        error: action.error,
      },
    }),
  ],

  ['redux-form/FOCUS']: [
    (action, state) => {
      if (action.form === 'setupform' &&
        !isTracked(state) &&
        fromTicketing()) {
        const portalUser = getIdentityPortalUser(state)
        return {
          name: 'First event creation started',
          properties: {
            category: 'Self service signup',
            partnerId: getCurrentPartnerId(state),
            partnerType: 'self-service',
            portalUserEmailAddress: portalUser.email,
            portalUserId: portalUser.id,
            setupFormField: action.field,
            setupFormId: getCurrentSetupformId(state),
          },
        }
      }
      return null
    },
  ],
}



/** WEBPACK FOOTER **
 ** ./src/middlewares/analytics/event-creators.js
 **/